/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import MsDyn365 from '@msdyn365-commerce/core';

import { IHsoCustomerRedirectData } from './hso-customer-redirect.data';
import { IHsoCustomerRedirectProps } from './hso-customer-redirect.props.autogenerated';

export interface IHsoCustomerRedirectViewProps extends IHsoCustomerRedirectProps<IHsoCustomerRedirectData> {}

/**
 *
 * HsoCustomerRedirect component
 * @extends {React.PureComponent<IHsoCustomerRedirectProps<IHsoCustomerRedirectData>>}
 */
class HsoCustomerRedirect extends React.PureComponent<IHsoCustomerRedirectProps<IHsoCustomerRedirectData>> {
    public render(): JSX.Element | null {
        if (this.props.context?.request?.apiSettings.channelCustomerType === 'B2C') {
            if (MsDyn365.isBrowser && this.props.context.request.user.isAuthenticated && !this.props.context.request.params.isEditor) {
                window.location.assign(this.props.context.request.user.signOutUrl || '/');
            }
        }

        return this.props.renderView(this.props);
    }
}

export default HsoCustomerRedirect;
